import { render, staticRenderFns } from "./TheNavbarButton.vue?vue&type=template&id=be429c8c&scoped=true&"
import script from "./TheNavbarButton.vue?vue&type=script&lang=js&"
export * from "./TheNavbarButton.vue?vue&type=script&lang=js&"
import style0 from "./TheNavbarButton.vue?vue&type=style&index=0&id=be429c8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be429c8c",
  null
  
)

export default component.exports